import React, { useEffect, useState, useRef, useMemo } from "react";

import { Dropdown, Button, ProgressBar } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";

import _ from "lodash";

import cx from "classnames";


import { BRANDKIT_THEME_OPTIONS, Font } from "components/Editor/components/properties/fonts";
import Header from "../../components/Header";
import { Fonts } from '@paperflite-marketing/cleverstory-commons';
import { FileUploadButton } from "components/Buttons";
import { 
  associateFontWithBrandkitText, 
  createBrandkitText, 
  deleteBrandkitFont, 
  deleteBrandkitNewText, 
  deleteBrandkitText, 
  fetchBrandkitFonts, 
  fetchBrandkitText, 
  initiateBrandkitFontUpload, 
  invalidateBrandkitText, 
  renameBrandkitText, 
  updateBrandkitFontUploadProgress, 
  updateBrandkitText, 
  updateBrandkitTextContent, 
  updateBrandkitTextProperty, 
  uploadBrandkitFont } from "actions/brandKit/text";
import { fetchFonts } from "actions/fonts";
import EmptyMessage from "../../components/EmptyMessage";
import InfiniteScroll from "components/InfiniteScroll";
import DeleteModal from "../../components/DeleteModal";
import { Property } from "components/Editor/components/properties";
import { calculateFontSizeForMobile } from "components/Editor/helper/text";
import { BRANDKIT_TEXT_COMPONENT } from "constants/brandKit/text";
import TruncatedTextWithTooltip from "components/TruncatedTextWithTooltip";
import Footer from "../../components/Footer";

import styles from "../brandkit.elements.module.scss";
import useToastMessage from "../../components/toastMessageHook";
import { MIXPANEL_BRANDKIT_CREATED } from "constants/mixpanelEvents";
import { createMixpanelEvent } from "actions/mixpanel";


const Options = [
  {
    name: "fonts",
    label: "Fonts",
  },
  {
    name: "text_Styles",
    label: "Text Styles",
  },
];

const tags = BRANDKIT_THEME_OPTIONS;

const CustomTagDropdown = React.forwardRef(({ children, onClick }, ref) => (
  <span
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className={styles.dropDownToggle}
  >
    {children}
    <i className={cx("cleverstory-drop-down")} />
  </span>
));

function TextElement() {
  const availableFonts = useSelector((state) => _.get(state, "fonts.items"));

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  const [state, setState] = useState({
    active: 'fonts',
    selected: []
  });

  const [toggleBrandElements, setToggleBrandElements] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const paletteIds = useSelector((state) => _.get(state, "brandKit.activated.items", []));
  const componentsList = useSelector(state => _.get(state, 'brandKit.text.components')) || [];
  const loading = useSelector(state => _.get(state, 'brandKit.text.loading', false));
  const deleting = useSelector(state => _.get(state, 'brandKit.text.deleting', false));
  const updating = useSelector(state => _.get(state, 'brandKit.text.updating', false));
  const loadingTextstyle = useSelector(state => _.get(state, 'brandKit.text.text.loading', false));
  const dataFetchedTextstyle = useSelector(state => _.get(state, 'brandKit.text.text.fetched', false));
  const updated = useSelector(state => _.get(state, 'brandKit.text.updated', false));
  const error = useSelector(state => _.get(state, 'brandKit.text.error', false));

  const paletteId = useMemo(
    () => _.find(paletteIds, { type: "TEXT" })?.id,
    [paletteIds]
  );

  const enabled = useMemo(
    () => _.find(paletteIds, { type: "TEXT" })?.enabled,
    [paletteIds]
  );

  useEffect(()=>{
    if (enabled != toggleBrandElements) {
      setToggleBrandElements(enabled)
    }
  },[enabled])

  useEffect(() => { 
    if(paletteId){
      dispatch(fetchBrandkitText(paletteId))
    }
  }, [paletteId])

  useEffect(() => {
    if (!loading && showDeleteModal && !deleting) {
      setShowDeleteModal(false);
      setState(state => {
        return {
          ...state,
          selected: []
        }
      });
    }
  }, [deleting]);

  useEffect(() => {
    setState(state => {
      return {
        ...state,
        selected: []
      }
    });
  },[updating])

  useToastMessage(updated, invalidateBrandkitText, error, 'Text');


  const handleTabChange = (active) => {
    setState(state => {
      return {
        active: active,
        selected:[]
      }
    })

    if (active == "text_Styles") {
      dispatch(fetchFonts());
    }
  }

  const handleUploadFont = (font) => {
    dispatch(uploadBrandkitFont(font));
  };

  const handleCreateText = () => {
    dispatch(
      createBrandkitText(BRANDKIT_TEXT_COMPONENT())
    );
    setTimeout(() => {
      containerRef.current?.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: 'smooth'
      })
    }, 300);
  };

  const deleteModalOpenHandler = () => {
    if (state.selected?.length === 0) return;
    setShowDeleteModal(true);
  };

  const resetHandler = () => {
    if(paletteId){
      dispatch(fetchBrandkitText(paletteId));
    }
  };

  const saveChangesHandler = () => {
    const request = componentsList
      ?.filter(({ changes }) => changes)
      .map(({ id, name, newComponent, draft, order }) => ({
        name,
        ...(newComponent ? {} : { id }),
        order,
        widgets: draft?.widgets || [],
      }));
  
    dispatch(updateBrandkitText(paletteId, request));

    var mixpanelPayload = {
      brandkit_element_type: "Text Styles"
    }

    dispatch(createMixpanelEvent(MIXPANEL_BRANDKIT_CREATED, mixpanelPayload));
  };

  const handleDelete = () => {

    if (state.active === 'fonts') {
      const ids = state?.selected?.map(item => item.id);

      if (ids.length > 0) {
        dispatch(deleteBrandkitFont(ids))
      }
    } else {
      const ids = state.selected
      .filter(item => !item.newComponent)
      .map(item => item.id);
  
      if (ids.length > 0) {
        dispatch(deleteBrandkitText(ids, paletteId))
      }
  
      const newComponentsIds = state.selected
      .filter(item => item.newComponent)
      .map(item => item.id);
  
      if (newComponentsIds.length > 0) {
        dispatch(deleteBrandkitNewText(newComponentsIds))
        if (!deleting) {
          setTimeout(() => {
            setShowDeleteModal(false);
            setState(state => {
              return {
                ...state,
                selected: []
              }
            })
          }, 500);
        }
      }
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={cx(styles.categoriesList, "px-2")}>
          {Options.map((data) => (
            <span
              onClick={() => handleTabChange(data.name)}
              className={cx(
                styles.icons,
                state.active === data.name && styles.iconSelected
              )}
              key={data.name}
            >
              {data.label}
            </span>
          ))}
        </div>
        <div className={styles.liner}></div>
        <div className={styles.mainContainer}>
          <Header
            selectedCategory={state.active}
            toggleBrandElements={toggleBrandElements}
            setToggleBrandElements={setToggleBrandElements}
            deleteHandler={deleteModalOpenHandler}
            selectedItems={state.selected}
            loading={loading}
            paletteId={paletteId}
          >
            {state.active === "text_Styles" ? (
              <Button 
                onClick={handleCreateText} 
                className={styles.uploadButton}
                style={{backgroundColor: isHovered ? "var(--primaryAppColor)" : "transparent"}}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <i className="cleverstory-upload" />
                {"New Text Style"}
              </Button>
            ) : (
              <FontPicker completeCallback={handleUploadFont} />
            )}
          </Header>

          <div className={styles.mainContentWrapper} ref={containerRef}>
            <div>
              {state.active === "fonts" ? 
               (<FontsStyles state={state} setState={setState}/>)
                :(
                  (loadingTextstyle && componentsList?.length === 0)? (
                    <div className={styles.loaderContainer}>
                      <label>Just a moon-ute... Scanning for text styles... </label>
                    </div>
                  ) : (dataFetchedTextstyle && !loadingTextstyle && componentsList?.length === 0) ? (
                    <div className={styles.emptyMsgContainer}>
                      <EmptyMessage />
                    </div>
                  ) : (
                    componentsList?.map((data) => (
                      <TextStyle
                        key={data.id}
                        deleting={deleting}
                        component={data}
                        availableFonts={availableFonts}
                        state={state}
                        setState={setState}
                        paletteId={paletteId}
                      />
                    ))
                  )
                )
              }
            </div>
          </div>
        </div>
      </div>

      {showDeleteModal && (
        <DeleteModal
          showDeleteModal={true}
          message={`Are you sure you want to delete ${
            state.selected?.length > 1
              ? `these ${state.selected?.length} files?`
              : `this file?`
          }`}
          title={`Delete ${
            state.active === "fonts" ? "Fonts" : "Text Style"
          }`}
          isDeleting={deleting}
          backdrop={deleting}
          cancelHandler={() => setShowDeleteModal(false)}
          handleDeleteClick={handleDelete}
        />
      )}

      {state.active === "text_Styles" && (
        <Footer        
          resetHandler={resetHandler}
          updating={updating}
          saveChangesHandler={saveChangesHandler}
          saveDisable={updating || componentsList?.length === 0}
          marginCondition={true}
        />
      )}
    </div>
  );
}

const FontsStyles = ({state, setState}) => {
  const dispatch = useDispatch();

  const multiple = true;
  const uploads = useSelector((state) => _.get(state, "brandKit.text.uploads"));
  const pagination = useSelector(state => _.get(state, 'brandKit.text.pagination'));
  const fontList = useSelector(state => _.get(state, 'brandKit.text.fonts')) || [];
  const loading = useSelector(state => _.get(state, 'brandKit.text.loading'));
  const dataFetched = useSelector(state => _.get(state, 'brandKit.text.fetched'));
  const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;

  Fonts.useFont(fontList);

  useEffect(() => {
      const request = {
        page: 0,
        limit: 20,
      };
      dispatch(fetchBrandkitFonts(request));
  }, []);


  const loadMoreFonts = () => {

    const nextPage = pagination.currentPage + 1;

    if (nextPage >= pagination.totalPages) {
      return;
    }

    const request = {
      page: pagination.currentPage + 1,
      limit: 20,
    };

    dispatch(fetchBrandkitFonts(request));
  };

  const handleSelect = (component) => {
    var updated = [...state.selected];

    if (multiple) {
      const exists = updated.find(m => m.id === component.id) != null;
      if (exists) {
        updated = updated.filter(m => m.id !== component.id);
      } else if (!component?.systemDefined){
        updated = [...updated, component];
      } else {
        updated = [...updated];
      }
    } else {
      updated = [component];
    }
    
    setState(state => {
      return {
        ...state,
        selected: updated
      }
    });
  }

  if (loading && fontList.length === 0 && !uploads.length) {
    return(       
      <div className={styles.loaderContainer}>
        <label>Just a moon-ute... Scanning for fonts... </label>
      </div>
    )
  }

  if (dataFetched && fontList.length === 0 && uploads.length === 0) {
    return (
      <div className={styles.emptyMsgContainer}>
        <EmptyMessage/>
      </div>
    )
  }

  return (
    <InfiniteScroll
      className={styles.fontsWrapper}
      loading={loading}
      hasMore={hasMoreItems}
      loadMore={loadMoreFonts}
    >
      {uploads?.map((upload) => {
        return (
          <div
            className={cx(styles.fontBlock, styles.fontUploadingBlock)}
            key={upload.id}
          >
            <div className={cx(styles.font, styles.fontUploading)}>
              {!upload?.processing ? (
                <ProgressBar variant="warning" now={upload.progress} />
              ) : (
                <div style={{ fontSize: "14px" }}>Processing...</div>
              )}
            </div>
          <TruncatedTextWithTooltip className={styles.fontName} maxWidth={165} content={upload?.name ? upload.name : "untitled"} placement='top' />
          </div>
        );
      })}
      {fontList?.map((font) => (
        <div
          key={font.id}
          className={cx(
            styles.fontBlock,
            (state.selected?.some(data => data.id === font.id)) && styles.fontBlockSelected
          )}
          onClick={() => handleSelect(font)}
        >
          <div className={styles.font}>
            <span style={{ fontFamily: font.fontFamily }}>Abg</span>
          </div>
          <TruncatedTextWithTooltip className={styles.fontName} maxWidth={165} content={font?.name ? font.name : "untitled"} placement='top' />
        </div>
      ))}
    </InfiniteScroll>
  );
};

function TextStyle({ component, deleting, state, setState, paletteId, availableFonts }) {
  const dispatch = useDispatch();

  const { id, name} = component || {};
  const multiple = true;
  const widget = component?.draft?.widgets?.[0] || {};
  const { content, properties, fonts, uid } = widget || {};
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = content && content;
  const contentStyle = tempDiv?.firstElementChild?.firstElementChild?.style
  const tagName = tempDiv?.firstElementChild?.tagName || 'h1';
  const selectedFont = useMemo(
    () => _.find(availableFonts, { id: fonts?.[0] || "" }),
    [fonts?.[0], availableFonts]
  );
  Fonts.useFont([selectedFont]);

  const [show, setShow] = useState(false);
  const [showColour, setShowColour] = useState(false);
  const [renameEnabled, setRenameEnabled] = useState(false);
  const [headerName, setHeaderName] = useState(name);
  const [deleteModal, setDeleteModal] = useState(false);
  const [textStyle, setTextStyle] = useState({
    fontFormat: tagName,
    fontWeight: contentStyle?.fontWeight || 'normal',
    fontStyle: contentStyle?.fontStyle || 'normal',
    fontFamily: selectedFont?.fontFamily || 'Montserrat,sans-serif',
    fontSize: contentStyle?.fontSize || '67',
  });

  const desktopFontSize = _.get(properties, 'desktop.fontSize');
  const color = _.get(properties, 'desktop.color') || {r: 0, g: 0, b: 0, a: 1, type: "solid"};
  const loading = useSelector(state => _.get(state, 'brandKit.text.loading', false));

  const inputRef = useRef(null);
  const colorTargetRef = useRef(null);

  useEffect(() => {
    const input = inputRef?.current;
    if (!input) return;
    input.value = name;
    setHeaderName(name);
  }, [name]);

  useEffect(() => {
    let input = inputRef?.current;
    if (!input) return;
    if (renameEnabled) {
      input.focus();
    }

    const blurHandler = () => {
      setRenameEnabled(false);
      renameHandler(id, input.value);
      setHeaderName(input.value);
    };

    const keyHandler = (event) => {
      if (event.key === "Enter") {
        blurHandler();
      }
    };

    input?.addEventListener("blur", blurHandler);
    input?.addEventListener("keydown", keyHandler);
    return () => {
      input?.removeEventListener("blur", blurHandler);
      input?.removeEventListener("keydown", keyHandler);
    };
  }, [renameEnabled]);

  useEffect(() => {
    let rgbaColor ;

    if (color?.a === 1) {
      rgbaColor = `rgb(${color?.r}, ${color?.g}, ${color?.b})`;
    } else {
      rgbaColor = `rgba(${color?.r}, ${color?.g}, ${color?.b}, ${color?.a})`;
    }

    const contentStyle = `"font-family: ${textStyle.fontFamily}; 
                          font-weight: ${textStyle.fontWeight}; 
                          font-style: ${textStyle.fontStyle}; 
                          font-size: ${desktopFontSize}px; 
                          color: ${rgbaColor};"`
                          
    const newContent = `<${textStyle.fontFormat} style=${contentStyle}>
                          <span style=${contentStyle}>${headerName}</span>
                        </${textStyle.fontFormat}>`;

    if (content !== newContent) {
      dispatch(updateBrandkitTextContent(id, uid, newContent, headerName));
    }
  }, [desktopFontSize, color, textStyle, headerName]);

  useEffect(() => {
    if (!loading && deleteModal && !deleting) {
      setDeleteModal(false);
      setState(state => {
        return {
          ...state,
          selected: []
        }
      });
    }
  }, [deleting]);
  

  const handlePropertyChange = (property) => {

    dispatch(
      updateBrandkitTextProperty(id, widget?.uid, property)
    );
};

  const handleFontFamily = (data) => {
    setTextStyle(state => {
      return {
        ...state,
        fontFamily: data?.font?.fontFamily
      }
    })
    dispatch(associateFontWithBrandkitText(id, uid, [data?.font?.id]));
  };

  const handleFontFormat = (data) => {
    setTextStyle(state => {
      return {
        ...state,
        fontFormat: data.value
      }
    })
    const property = {
      ...properties,
      desktop: {
        ...properties?.desktop,
        fontSize: data.desktopFontSize
      },
      mobile: {
        ...properties?.mobile,
        fontSize: calculateFontSizeForMobile(data.desktopFontSize)
      }
    };

    handlePropertyChange(property)
  };

  const handleFontSize = (fontSize) => {
    const property = {
      ...properties,
      desktop: {
        ...properties?.desktop,
        fontSize: fontSize
      },
      mobile: {
        ...properties?.mobile,
        fontSize: calculateFontSizeForMobile(fontSize)
      }
    };
    if (fontSize === "" || (Number(fontSize) <= 150)) {
      handlePropertyChange(property);
    }

  };

  const handleFontBold = () => {
    setTextStyle(state => {
      return {
        ...state,
        fontWeight: state.fontWeight == 'bold' ? 'normal' : 'bold'
      }
    })
  };

  const handleFontStyle = () => {
    setTextStyle(state => {
      return {
        ...state,
        fontStyle: state.fontStyle == 'italic' ? 'normal' : 'italic'
      }
    })
  };

  const handleColorChange = (data) => {
    const property = {
      ...properties,
      desktop: {
        ...properties?.desktop,
        color: data
      },
    };

    handlePropertyChange(property);
  };

  const handleSelect = (text) => {
    var updated = [...state.selected];

    if (multiple) {
      const exists = updated.find(m => m.id === text.id) != null;
      if (exists) {
        updated = updated.filter(m => m.id !== text.id);
      } else {
        updated = [...updated, text];
      }
    } else {
      updated = [text];
    }
    
    setState(state => {
      return {
        ...state,
        selected: updated
      }
    })
  }

  const handleDelete = () => {

    if (component.newComponent) {
      dispatch(deleteBrandkitNewText([id]))

      if (!deleting) {
        setTimeout(() => {
          setDeleteModal(false);
          setState(state => {
            return {
              ...state,
              selected: []
            }
          })
        }, 500);
      }
    } else {
      dispatch(deleteBrandkitText([id], paletteId))
    }
  };

  const renameHandler = (id, name) => {
    dispatch(renameBrandkitText(id, name));
  };

  return (
    <div
      onClick={() => handleSelect(component)}
      className={cx(
        styles.componentStyleWrapper,
        state.selected.some(data => data.id === id) &&
        styles.componentStyleWrapperSelected
      )}
    >

      <div className={styles.newStyleHeaderWrapper}>
        <div>
          {!renameEnabled ?
            <TruncatedTextWithTooltip             
              content={headerName} 
              maxWidth={200}
            />
            :
            <input
              ref={inputRef}
              maxLength={120}  
              value={headerName}
              onChange={(e) => setHeaderName(e.target.value)}
              className={styles.widgetHeadingName}
              disabled={!renameEnabled}
            />
          }
        </div>
        <div className={styles.moreOptionsWrapper}>
          <Button
            variant="secondary"
            className={styles.btnIcons}
            onClick={(e) => {
              setShow(!show);
              e.stopPropagation();
            }}
          >
            <i className={"cleverstory-more"} />
          </Button>
          {show && (
            <div
              className={styles.moreOptionsList}
              onClick={(e) => e.stopPropagation()}
            >
              <span
                onClick={() => {
                  setRenameEnabled(!renameEnabled);
                  setShow(false);
                  inputRef?.current?.focus();
                }}
              >
                Rename
              </span>
              <span
                onClick={() => {
                  setShow(false);
                  setDeleteModal(true);
                }}
              >
                Delete
              </span>
            </div>
          )}
        </div>

        {deleteModal && (
          <DeleteModal
            showDeleteModal={true}
            message={`Are you sure you want to delete ${headerName}?`}
            title={"Delete Text Style"}
            cancelHandler={() => setDeleteModal(false)}
            isDeleting={deleting}
            backdrop={deleting}
            handleDeleteClick={handleDelete}
          />
        )}
      </div>
      <div className={styles.textEditorCard}>
        <ul
          className={styles.featureWrapper}
          onClick={(e) => e.stopPropagation()}
        >
          <li>
            <Font.Family
              name={""}
              className={styles.fontFamilyWrapper}
              value={(textStyle?.fontFamily) || 'Montserrat,sans-serif'}
              onChange={handleFontFamily}
            />
          </li>
          <li>
            <Dropdown className={styles.storboardTypeDropdown}>
              <Dropdown.Toggle
                as={CustomTagDropdown}
                id="dropdown-custom-components"
              >
                {(textStyle.fontFormat).toUpperCase()}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {tags.map((option, index) => {
                  return (
                    <Dropdown.Item
                      active={option.value == (textStyle.fontFormat).toLowerCase()}
                      onClick={() => handleFontFormat(option)}
                      key={index}
                      eventKey={index}
                    >
                      {option.label}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </li>
          <li>
            <input
              className={styles.fontSizeInput}
              value={desktopFontSize}
              onKeyPress={(e) => {
                if (!/^[0-9]$/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              onChange={(e) => handleFontSize(e.target.value)}
            />
          </li>
          <li>
            <Button
              variant={"secondary"}
              className={styles.btnIcons}
              onClick={handleFontBold}
              style={{
                backgroundColor:
                  textStyle.fontWeight === "bold" ? "var(--bs-gray-200)" : "transparent",
              }}
            >
              <i className={"cleverstory-bold"} />
            </Button>
          </li>
          <li>
            <Button
              variant={"secondary"}
              className={styles.btnIcons}
              onClick={handleFontStyle}
              style={{
                backgroundColor:
                  textStyle.fontStyle === "italic" ? "var(--bs-gray-200)" : "transparent",
              }}
            >
              <i className={"cleverstory-italics"} />
            </Button>
          </li>
          <li>
            <Button
              variant="secondary"
              className={styles.colourBtn}
              onClick={() => setShowColour(!showColour)}
              ref={colorTargetRef}
            >
              <i className="cleverstory-font-color"></i>
              <i className={"cleverstory-drop-down"} />
            </Button>
            {showColour && (
              <Property.ColorPickerDialog
                target={colorTargetRef.current}
                colorConfig={color}
                value={color}
                onChange={handleColorChange}
                onCancel={() => setShowColour(false)}
                brandkit={true}
              />
            )}
          </li>
        </ul>
        <div className={cx(styles.innerContent) } dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
}

function FontPicker({ name, completeCallback }) {
  const dispatch = useDispatch();

  const handleUploadStart = (instances) => {
    const instance = instances[0];

    const upload = {
      id: instance.files[0].id,
      name: instance.files[0].name,
      type: instance.files[0].type,
      progress: 0,
    };

    dispatch(initiateBrandkitFontUpload(upload));
    const ttfExtension = instance.files[0].name.endsWith(".ttf");
    if (instance.files[0].type !== "font/ttf" && !ttfExtension) {
      return;
    }
  };

  const handleUploadProgress = (file, progress) => {
    dispatch(updateBrandkitFontUploadProgress(file.id, progress));
  };

  const handleUploadComplete = (info, file) => {

    const ttfExtension = file.name.endsWith(".ttf");
    if ((info && file.type === "font/ttf") || (info && ttfExtension)) {
      const request = {
        fileName: file.name,
        signedUrl: info.signedUrl,
      };

      dispatch(uploadBrandkitFont(file.id, request, completeCallback));

      var mixpanelPayload = {
        brandkit_element_type: "Fonts"
      }
  
      dispatch(createMixpanelEvent(MIXPANEL_BRANDKIT_CREATED, mixpanelPayload));
    }
  };

  return (
    <FileUploadButton
      className={cx(styles.upload)}
      name={name || "fontFile"}
      accept={"font/ttf"}
      onStart={handleUploadStart}
      onProgress={handleUploadProgress}
      onComplete={handleUploadComplete}
    >
      <Button variant="primary" className={styles.uploadButton}><i className="cleverstory-upload" />Upload Fonts</Button>
    </FileUploadButton>
  );
}


export default TextElement;